import React from "react";
import SettingTabComponent from "./settingTab.component";

function SettingTabContainer() {
  return <SettingTabComponent />;
}

export default SettingTabContainer;
